module.exports = __webpack_public_path__ + "img/toolsItem12.bdd7d9b9.png";